import { AuthState } from './AuthTypes';

export const AuthActionTypes = {
  SIGN_IN: 'signIn',
  SIGNED_IN: 'signedIn',
  SIGN_IN_ERROR: 'signInFailed',
  SIGN_OUT: 'signOut',
  SIGNED_OUT: 'signedOut',
  RECONNECTING: 'reConnecting',
};

export const DEFAULT_STATE: AuthState = {
  is_logged_in: false,
  reconnect: false,
  access_token: '',
  error_message: '',
};
